import React, { RefObject, useEffect, useRef } from "react";

import styles from "./default-modal.module.scss";
import { DefaultModalProps } from "./default-modal.types";

const DefaultModal: React.FC<DefaultModalProps> = (props: DefaultModalProps) => {
  const ref: RefObject<HTMLDivElement> = useRef<HTMLDivElement>(null);

  const handleCloseModal: () => void = () => {
    props.setModalState(false);
  };

  const handleMouseEvent: (e: MouseEvent) => void = (e: MouseEvent): void => {
    if (props.modalState && ref.current && !ref.current.contains(e.target as HTMLDivElement)) {
      props.setModalState(false);
    }
  };

  const handleKeyDownOnInput: (event: KeyboardEvent) => void = (event: KeyboardEvent): void => {
    if (event.key === "Escape") {
      props.setModalState(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", (e): void => handleMouseEvent(e), true);
    window.addEventListener("keydown", (e): void => handleKeyDownOnInput(e), true);
    return (): void => {
      document.removeEventListener("click", (e): void => handleMouseEvent(e), true);
      window.removeEventListener("keydown", (e): void => handleKeyDownOnInput(e), true);
    };
  }, [props.modalState]);

  return (
    <div className={styles.modal}>
      <div className={styles.modalContainer} ref={ref}>
        <div className={styles.modalHeader}>
          <div className={styles.modalTitle}>{props.title}</div>
        </div>
        <div className={styles.modalContent}>{props.children}</div>
        <div className={styles.modalButtons}>
          {props.actionDelete && (
            <button className={styles.buttonDelete} onClick={props.actionDelete}>
              Delete
            </button>
          )}
          <button className={styles.buttonCancel} onClick={handleCloseModal}>
            Cancel
          </button>
          {props.action && (
            <button className={styles.buttonDone} onClick={props.action}>
              Done
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DefaultModal;
